<template>
    <div>
        <FreeGiftRedeemButton
            :isLogin="isLogin"
            :point="availablePoint"
            :selectedPoint="selectedPoint"
            :selectedQuantity="selectedQuantity"
            :lblRedeemBTN="lbl.redeem_button"
            :campaign="campaign"
            :redeemBTN="redeemBTN"
            v-if="isForceRender"
            @clickRedeem="clickRedeem()">
        </FreeGiftRedeemButton>

        <modal view="redeem-component"
            :busModal="busModal"
            @modalAlertHidden="clickOkModalAlert($event)"></modal>

        <SelectSubCampaignModal
            :lbl="lbl"
            :campaign="campaign"
            :busModal="busSelectStore"
            @clickConfirmSelectBranch="clickConfirmSelectBranch($event)">
        </SelectSubCampaignModal>

        <ConfirmRedeemFreeGiftModal
            :lbl="lbl"
            :campaign="campaign"
            :busModal="busConfirmRedeem"
            @clickConfirmRedeem="clickConfirmRedeem()">
        </ConfirmRedeemFreeGiftModal>

        <ConfirmRedeemGift
            :errorMessage="errorMessage"
            :lbl="lbl"
            :campaign="campaign"
            :busModal="busConfirmRedeemGift"
            @clickCancelSelectStore="clickCancelSelectStore($event)"
            @clickConfirmRedeem="clickConfirmRedeem($event)"
            @clickShowCondition="clickShowCondition($event)">
        </ConfirmRedeemGift>

        <SuccessRedeemGiftModal
            :lbl="lbl"
            :campaign="campaign"
            :busModal="SuccessModal"
            @clickUse="clickUse()">
        </SuccessRedeemGiftModal>

        <SerialFreegiftModal
            :lbl="lbl"
            :busSerialModal="busSerialModal">
        </SerialFreegiftModal>

    </div>
</template>
<script>
import Vue from "vue";
import Util from "@/helper/Utility.js";
import Account from '@/helper/AccountHelper.js';
import FreeGiftRedeemButton from './FreeGiftRedeemButton.vue';
import Locale from '@/helper/locale/locale.js';
//Service
import BzbsCampaign from '@/service/BzbsCampaign.js';
// import BzbsHistory from '@/service/BzbsHistory.js';
import {
    CampaignConfigBuilder,
    RedeemConfigBuilder,
    RedeemShippingAdressBuilder,
    RedeemInfoConfigBuilder
} from '@/service/config/CampaignConfigModel.js';

//Modal
import ConfirmRedeemFreeGiftModal from '../../Modal/ConfirmRedeemFreeGiftModal.vue';
import Modal from '@/components/modal/Modal.vue';
import SelectSubCampaignModal from "../../Modal/SelectSubCampaignModal.vue";
import ConfirmRedeemGift from "../../Modal/ConfirmRedeemGift.vue";
import SuccessRedeemGiftModal from "../../Modal/SuccessRedeemGiftModal.vue";
import SerialFreegiftModal from '../../Modal/SerialFreegiftModal.vue';
//helper
import DatetimeHelper from "@/helper/DatetimeHelper.js";

/**
 * Property
 * @property {object} lbl Text for Component.
 * @property {object} campaign Campaign model.
 * @property {number} selectedId Selected campaign for redeem in case of campaign contain sub-campaign.
 * @property {number} selectedQuantity Selected campaign quantity.
 * @property {number} selectedPoint Selected campaign use/get point.
 * Event
 * @event clickRedeem Click validate redeem.
 * @event clickConfirmRedeem Click confirm to proceed redeem define type of campaign.
 * Method
 * @method checkRedeemCondition Check if user can or cannot redeem.
 * @method openWebsite Redirect by campaign condition to website after redeem.
 * @method openSurvey Redirect by campaign condition to website after redeem.
 * @method callInterfaceApi Call api by campaign condition after redeem.
 * @method initialShippingAddress Setup data model and open shipping address modal.
 * @method clickConfirmAddress Validate shipping address and proceed redeem.
 * @method redeem Call redeem api for redeem.
 * @method updateCampaign Call Campaign detail api to update data.
 * @method updateCampaignInfo Emit parent method to update data.
 * @method initialSerialModal Open Serial modal.
 * Utilities
 * @method forceRender Force component to rerender.
 */
export default {
    name: "Redeem",
    components: {
        FreeGiftRedeemButton,
        Modal,
        SelectSubCampaignModal,
        ConfirmRedeemGift,
        SuccessRedeemGiftModal,
        ConfirmRedeemFreeGiftModal,
        SerialFreegiftModal

    },
    props: {
        lbl: Object,
        campaign: Object,
        selectedId: Number,
        selectedQuantity: Number,
        selectedPoint: Number,
        tracking: Object
    },
    data: function() {
        return {
            isLogin: false,
            availablePoint: 0,
            profileDior: {},
            redeemBTN: {
                strRedeemLabel: '',
                isAllowRedeem: true,
                isButtonDisable: false,
                strDisableClass: 'redeem-disable',
                isUseDefault: false
            },
            redeemConfig: null,
            redeemShippingAdress: null,
            redeemInfoConfig: null,
            redeemLocation: null,
            redeemOtherConfig: null,
            campaignConfig: null,

            serialCampaign: {},
            isForceRender: true,

            shippingAddress: null,
            errorMessage: null,
            shippingAddressValidateInfo: {
               isValid: true,
               msg: ''
            },

            objRedeemInfoConfig: {
                info3: ''
            },
            information: {},
            busModal: new Vue(),
            busSelectStore: new Vue(),
            busConfirmRedeemGift: new Vue(),
            busConfirmRedeem: new Vue(),
            busCondition: new Vue(),
            SuccessModal: new Vue(),
            busSerialModal: new Vue(),
            selectedName: "",
            redeemId: '',
            trackCamp: '',
            userId: '',
            // busConfirmRedeem: new Vue(),
        };
    },
    created: function() {
        // console.log("Redeem");
        Account.loginStatus().then((status) => {
            this.isLogin = status;
            this.profileDior = Account.getCacheDiorProfile();
            if (this.profileDior && this.profileDior.bonusPointBalance) {
                this.availablePoint = parseInt(this.profileDior.bonusPointBalance);
            }
            this.forceRender();
            console.log(this.campaign);
            this.userId = Account.getLineUserId();
            this.trackCamp = this.userId + "|" + this.campaign.id + "|" + this.campaign.name;
        });
        this.redeemConfig = new RedeemConfigBuilder().create();
    },
    mounted: function() {
        this.redeemId = this.selectedId;
        //this.busConfirmBooking.$emit('showConfirmSelectBookingModal', {});
    },
    methods: {
        //Event
        clickRedeem: function () {
            if(!this.redeemBTN.isAllowRedeem) return;
            if(!this.isLogin) return;

            if (this.campaign.subCampaignStyles && this.campaign.subCampaignStyles.styles.length > 0) {
                this.tracking.event('Privilege', 'click_Redeem', this.trackCamp);
                this.busSelectStore.$emit('showSelectStoreModal', this.campaign.subCampaignStyles.styles);
            } else {
                this.busConfirmRedeem.$emit('showConfirmRedeemModal', {});
            }
        },
        clickConfirmRedeem: function () {
            var strRedeemCondition = this.checkRedeemCondition();

            switch(strRedeemCondition) {
                case 'open_web':
                    this.openWebsite();
                    break;
                case 'open_web_survey':
                    this.openSurvey();
                    break;
                case 'call_api':
                    this.callInterfaceApi();
                    //No longer see this being use.
                    break;
                case "update_shipping_address":
                    this.initialShippingAddress();
                    break;
                default:
                    this.redeem();

                    break;
            }


        },
        clickConfirmSelectBranch: function (data) {

            this.redeemId = data.id;
            this.selectedName = data.name;
            // this.busConfirmRedeemGift.$emit('showConfirmRedeemGiftModal', this.information);
            this.redeem();
        },
        clickCancelSelectStore: function () {
            this.errorMessage = "";
        },
        clickShowCondition: function () {

            this.busCondition.$emit('showModal');
        },
        clickCloseCondition: function () {

            this.busConfirmRedeemGift.$emit('showConfirmRedeemGiftModal');
        },
        //Function
        checkRedeemCondition: function () {
            var strResult = 'redeem';
            switch(this.campaign.type) {
                case Vue.CampaignType.Buy:
                    strResult = 'open_web';
                    break;
                case Vue.CampaignType.Interface:
                    if(!this.campaign.interfaceDisplay) return;

                    if(this.campaign.interfaceDisplay === 'web') strResult = 'open_web';
                    if(this.campaign.interfaceDisplay === 'survey' || this.campaign.interfaceDisplay === 'surveyapprove') strResult = 'open_web_survey'
                    if(this.campaign.interfaceDisplay === 'api') strResult = 'call_api';
                    break;
                default:
                    if(this.campaign.delivered) strResult = 'update_shipping_address';
                    break;
            }

            return strResult;
        },
        openWebsite: function () {
            if(!this.campaign.website) return;

            var bzbsToken = Account.getToken();
            var localeCode = Locale.getLocaleCode();
            var returnUrl = encodeURIComponent(window.location.href);
            switch(this.campaign.type) {
                case Vue.CampaignType.Buy:
                    var strUrl = '';
                    var strLocale = '';
                    var strEncryptToken = Util.shuffleToken(bzbsToken);
                    switch(localeCode) {
                        case 1033:
                            strLocale = 'E';
                            break;
                        case 1054:
                            strLocale = 'T';
                            break;
                    }

                    if(this.campaign.website.indexOf('.buzzebees.com/payment/')) {
                        var arrSplittedUrl = this.campaign.website.split('/payment');
                        strUrl = Vue.bzbsConfig.bzbShoppingCartUrl + '/payment' + arrSplittedUrl[1] + '&token=' + strEncryptToken + '&return_url=' + returnUrl + '&locale=' + strLocale;
                    } else {
                        strUrl = this.campaign.website = '&token=' + strEncryptToken + '&return_url=' + returnUrl + '&locale=' + strLocale;
                    }

                    window.location = strUrl;
                    break;
                case Vue.CampaignType.Interface:
                    var isShowHeader = 'false' //show/hide header.
                    var strTheme = '';
                    window.location.href = this.campaign.website + '&token=' + bzbsToken + '&locale=' + localeCode + '&header=' + isShowHeader + '&theme=' + strTheme + '&return_url=' + returnUrl; // ReturnUrl;
                    break;
            }
        },
        openSurvey: function () {

        },
        callInterfaceApi: function () {

        },
        //Shipping
        initialShippingAddress: function () {
            this.shippingAddress = Account.getCacheProfileShippingAddres();
            this.busShippingModal.$emit('showShippingAddressModal', {});
        },
        clickConfirmAddress: function () {
            if(!this.shippingAddressValidateInfo.isValid) {
                this.showAlertModal(this.lbl.shipping.alert_headline,
                                    this.shippingAddressValidateInfo.msg,
                                    this.lbl.shipping.alert_ok_btn,
                                    "shipping");
            } else {
                this.redeemShippingAdress = new RedeemShippingAdressBuilder()
                                                .initialWithProfileShippingAddress(this.shippingAddress)
                                                .create();

                this.redeem();
            }
        },
        //Redeem
        redeem: function () {

            if(!this.redeemBTN.isAllowRedeem) return;
            console.log("redeem");
            this.showLoading();

            var diorProfile = Account.getCacheDiorProfile();

            var objDataSuccessModal = {
                username: diorProfile.memberName,
                branchName: this.selectedName,
                campaignName: this.campaign.name,
            }
            this.redeemConfigInfo = new RedeemInfoConfigBuilder()
                                                .setInfo3(this.selectedName)
                                                .create();
            console.log("objDataRedeem", objDataSuccessModal);
            var refcode = this.campaign.referenceCode;
            var bzbsToken = Account.getToken();
            BzbsCampaign.apiRedeemCampaign(bzbsToken, this.redeemId, this.redeemConfig, this.redeemShippingAdress, this.redeemConfigInfo, null, null, null)
                .then((campaign) => {
                    this.campaign.branchName = this.selectedName;
                    console.log("this.campaign", this.campaign)
                    this.busConfirmRedeemGift.$emit('hideConfirmRedeemGiftModal');
                    this.SuccessModal.$emit('showModal', objDataSuccessModal);
                    this.campaign.updateAfterRedeem(campaign);
                    this.updateCampaign()

                    this.campaign.referenceCode = refcode;
                    this.hideLoading();


                }).catch((error) => {
                    this.hideLoading();
                    console.log(error);
                });
        },
        clickUse: function () {

            this.initialSerialModal(this.campaign);
        },
        // clickUseNow: function (campaign) {

        //     this.showLoading();
        //     var bzbsToken = Account.getToken();
        //     BzbsHistory.apiRedeemUse(bzbsToken, campaign.redeemKey)
        //         .then((campaign) => {
        //             console.log(campaign);
        //             // this.campaign.isUsed = true;
        //             this.hideLoading();
        //             this.initialSerialModal(this.campaign);

        //         }).catch((error) => {
        //             this.hideLoading();
        //             console.log(error);
        //         });
        // },
        updateCampaign: function () {
            var strBzbsToken = Account.getToken();
            this.campaignConfig = new CampaignConfigBuilder()
                    .setCampaignId(this.campaign.id)
                    .create();
            BzbsCampaign.apiGetCampaignDetail(strBzbsToken, this.campaignConfig).then((data) => {
                this.campaign.updateCondition(data)
                console.log("this.campaign", this.campaign)
                // this.campaign = data;
                // this.updateCampaignInfo(data);
                this.forceRender();
            }).catch((error) => {
                console.log(error);
            });
        },
        updateCampaignInfo: function (campaign) {
            this.$emit('updateCampaignInfo', campaign);
        },
        initialSerialModal: function () {
            this.serialCampaign = this.campaign;
            console.log(this.serialCampaign)
            console.log(this.campaign)

            this.busSerialModal.$emit('showSerialModal', this.serialCampaign);
        },
        getRedeemDate: function () {
            return DatetimeHelper.getDateFormat();
        },
        //Utilities
        forceRender: function () {
            this.isForceRender = false;

            this.$nextTick().then( () => {
                this.isForceRender = true;
            });
        },
        // --- modal event ----
        modalConfirmOk: function(event) {
            if (event.tag == 'modal-redeem') {
                this.clickConfirmRedeem();
            }
        },
        showConfirmModal: function(title, message, btnOk, btnCancel, tag) {
            var configModal = {
                title: title,
                message: message,
                strBtnOk: btnOk,
                strBtnCancel: btnCancel,
                tag: tag,
            };
            this.busModal.$emit('showConfirmModal', configModal);
        },
        showAlertModal: function(title, message, btnOk, tag) {
            var configModal = {
                title: title,
                message: message,
                strBtnOk: btnOk,
                tag: tag,
            };
            this.busModal.$emit('showAlertModal', configModal);
        },
        clickOkModalAlert: function (e) {
            switch(e.tag) {
                case 'shipping':
                    this.busShippingModal.$emit('showShippingAddressModal', {});
                    break;
            }
        },
        showThankModal: function(title, message, btnOk, tag) {
            var configModal = {
                title: title,
                message: message,
                strBtnOk: btnOk,
                tag: tag,
            };
            this.busModal.$emit('showThankModal', configModal);
        },
        showLoading: function() {
            this.busModal.$emit('showLoadingModal', {});
        },
        hideLoading: function() {
            this.busModal.$emit('hideLoadingModal', {});
        },
        getPointMessage: function () {
            var pointUnit = this.lbl.campaign.point + (this.campaign.pointPerUnit != 1 && Locale.getLocaleCode() == 1033 ? 's' : '');
            return Util.formatNum(this.campaign.pointPerUnit) + " " + pointUnit;
        },
    } // end methods
};
</script>
